import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  // {
  //   name: 'orderCreatedAt',
  //   label: '',
  //   hidden: true,
  // },
  {
    name: 'orderCreatedAt',
    label: 'Created Date',
    sortable: true,
  },
  {
    name: 'sum',
    label: 'Amount',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: false,
  },
  {
    name: 'recepientAccountId',
    label: 'Beneficiary',
    sortable: false,
  },
  {
    name: 'status',
    label: 'Status',
    sortable: false,
  },
  {
    name: 'orderNumber',
    label: 'Cash bag number',
    sortable: false,
  },
];

export const columnsLabels = {
  currencyId: 'Currency',
  recepientAccountId: 'Beneficiary',
  status: 'Status',
  orderCreatedAt: 'Date created',
  orderCreatedAtFrom: 'Date created From',
  orderCreatedAtTo: 'Date created To',
};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  orderCreatedAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['orderCreatedAtFrom', 'orderCreatedAtTo'],
  },
  orderCreatedAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  orderCreatedAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recepientAccountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'orderCreatedAt',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  {
    name: 'status',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'status',
        title: 'Pending Review',
        value: 'QUEUED',
      },
      {
        name: 'status',
        title: 'Accepted',
        value: 'ACCEPTED',
      },
      {
        name: 'status',
        title: 'AML',
        value: 'AML',
      },
      {
        name: 'status',
        title: 'AML Done',
        value: 'AML_DONE',
      },
      {
        name: 'status',
        title: 'Proc',
        value: 'PROC',
      },
      {
        name: 'status',
        title: 'Rejected',
        value: 'REJECTED',
      },
      {
        name: 'status',
        title: 'AML Rejected',
        value: 'AML_REJ',
      },
    ],
  },
  {
    name: 'recepientAccountId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
];
